(function () {
  'use strict';

  var ROOT_SELECTOR = '[data-florame-account-center]';
  var TRIGGER_SELECTOR = '[data-florame-account-trigger]';
  var HAPTICS_KEY = 'florame_haptics_enabled';
  var THEME_KEY = 'florame-theme-preference';
  var WEB_PUSH_HASH_KEY = 'florame_web_push_subscription_hash';
  var LANGUAGE_KEYS = ['florame_native_lang', 'bouquetLanguage'];
  var WEB_CUSTOMER_ID_KEY = 'florame_customer_id';
  var WEB_CUSTOMER_EMAIL_KEY = 'florame_customer_email';
  var AUTH_CONTEXT_KEY = 'florame_account_auth_context_v1';
  var AUTH_PROBE_INTERVAL_MS = 12000;
  var instances = [];
  var authProbePromise = null;
  var lastAuthProbeAt = 0;
  var pendingPointerTrigger = null;
  var pointerActivationTimer = 0;

  var COPY = {
    it: {
      checking: 'Controllo disponibilità…',
      active: 'Attive',
      inactive: 'Da attivare',
      complete: 'Da completare',
      denied: 'Bloccate nelle impostazioni',
      deniedHelp: 'Apri il lucchetto del browser, consenti le notifiche e riprova',
      unsupported: 'Non disponibili su questo dispositivo',
      unavailable: 'Servizio momentaneamente non disponibile',
      installFirst: 'Installa Florame per attivarle',
      nativeAction: 'Tocca per verificare e attivare',
      nativeActive: 'Attive sul dispositivo',
      notificationsError: 'Non è stato possibile aggiornare le notifiche',
      hapticsOn: 'Attiva',
      hapticsOff: 'Spenta',
      hapticsUnsupported: 'Non supportata su questo dispositivo',
      installing: 'Apro le istruzioni…',
      helpTitle: 'Supporto Florame',
      helpDescription: 'FAQ, contatti email diretti e chat quando ti serve.',
      chatOpening: 'Apro la chat…',
      chatUnavailable: 'La chat non è disponibile in questo momento. Riprova tra poco.',
      authTitle: 'Accedi per continuare',
      authMessagesDescription: 'Ritrova conversazioni e richieste senza perdere il punto in cui eri.'
    },
    en: {
      checking: 'Checking availability…',
      active: 'On',
      inactive: 'Ready to enable',
      complete: 'Setup incomplete',
      denied: 'Blocked in device settings',
      deniedHelp: 'Open the browser lock, allow notifications, then try again',
      unsupported: 'Not available on this device',
      unavailable: 'Service temporarily unavailable',
      installFirst: 'Install Florame to enable them',
      nativeAction: 'Tap to check and enable',
      nativeActive: 'On for this device',
      notificationsError: 'Notifications could not be updated',
      hapticsOn: 'On',
      hapticsOff: 'Off',
      hapticsUnsupported: 'Not supported on this device',
      installing: 'Opening instructions…',
      helpTitle: 'Florame support',
      helpDescription: 'FAQs, direct email contacts and chat when you need it.',
      chatOpening: 'Opening chat…',
      chatUnavailable: 'Chat is unavailable right now. Please try again shortly.',
      authTitle: 'Sign in to continue',
      authMessagesDescription: 'Return to the same conversation or request without losing your place.'
    }
  };

  function storageGet(key) {
    try { return window.localStorage.getItem(key); } catch (_) { return null; }
  }

  function storageSet(key, value) {
    try { window.localStorage.setItem(key, String(value)); } catch (_) {}
  }

  function storageRemove(key) {
    try { window.localStorage.removeItem(key); } catch (_) {}
  }

  function emit(name, detail) {
    try { window.dispatchEvent(new CustomEvent(name, { detail: detail || {} })); } catch (_) {}
  }

  function isNativeAccountActive() {
    try {
      if (window.__loggedCustomer && window.__loggedCustomer.nativeApp) return true;
      if (document.documentElement.getAttribute('data-florame-native-signed-in') === 'true') return true;
      return storageGet('florame_native_signed_in') === '1';
    } catch (_) { return false; }
  }

  function rootIsAuthenticated(root) {
    return !!root && root.getAttribute('data-authenticated') === 'true';
  }

  function applyWebCustomerIdentity(customerId, customerEmail) {
    var normalizedId = customerId == null ? '' : String(customerId).trim();
    var normalizedEmail = customerEmail == null ? '' : String(customerEmail).trim().toLowerCase();

    if (normalizedId) storageSet(WEB_CUSTOMER_ID_KEY, normalizedId);
    else storageRemove(WEB_CUSTOMER_ID_KEY);
    if (normalizedEmail) storageSet(WEB_CUSTOMER_EMAIL_KEY, normalizedEmail);
    else storageRemove(WEB_CUSTOMER_EMAIL_KEY);

    try {
      var loggedCustomer = window.__loggedCustomer && typeof window.__loggedCustomer === 'object'
        ? window.__loggedCustomer
        : {};
      loggedCustomer.id = normalizedId || null;
      loggedCustomer.email = normalizedEmail || null;
      window.__loggedCustomer = loggedCustomer;
      window.AWI_CUSTOMER_EMAIL = normalizedEmail || null;
      window.__AWI_CUSTOMER_EMAIL = normalizedEmail || null;
      window.customerEmail = normalizedEmail || null;
      window.__customerEmail = normalizedEmail || null;
      window.HOMEPAGE_INIT_CUSTOMER_EMAIL = normalizedEmail || null;
      if (window.customerData && typeof window.customerData === 'object') {
        window.customerData.email = normalizedEmail || null;
      }
      if (normalizedEmail) document.documentElement.setAttribute('data-customer-email', normalizedEmail);
      else document.documentElement.removeAttribute('data-customer-email');
    } catch (_) {}

    try {
      if (window.__florameWebPushConfig) {
        window.__florameWebPushConfig.customerId = normalizedId || null;
        window.__florameWebPushConfig.customerEmail = normalizedEmail || null;
      }
    } catch (_) {}
  }

  function syncClientAuthFromServer(instance) {
    if (!instance || !instance.root) return;
    var authenticated = rootIsAuthenticated(instance.root);
    var customer = window.__loggedCustomer || {};
    var customerId = authenticated && customer.id != null ? String(customer.id).trim() : '';
    var customerEmail = authenticated && customer.email ? String(customer.email).trim() : '';

    if (!authenticated && isNativeAccountActive()) {
      emit('florame:auth-state', {
        authenticated: true,
        customerId: customer.id || null,
        customerEmail: customer.email || null,
        source: 'native-app'
      });
      return;
    }

    applyWebCustomerIdentity(customerId, customerEmail);
    emit('florame:auth-state', {
      authenticated: authenticated,
      customerId: customerId || null,
      customerEmail: customerEmail || null,
      source: 'shopify-server'
    });
  }

  function authProbeUrl() {
    try {
      var url = new URL(window.location.href);
      url.hash = '';
      url.searchParams.set('_florame_auth_probe', String(Date.now()));
      return url.pathname + url.search;
    } catch (_) {
      return String(window.location.pathname || '/') + '?_florame_auth_probe=' + Date.now();
    }
  }

  function parsedAuthState(html) {
    if (!html || typeof window.DOMParser !== 'function') return null;
    try {
      var parsed = new window.DOMParser().parseFromString(html, 'text/html');
      var root = parsed.querySelector(ROOT_SELECTOR);
      if (!root) return null;
      return root.getAttribute('data-authenticated') === 'true';
    } catch (_) { return null; }
  }

  function ensureAuthFresh(instance, options) {
    if (!instance || !instance.root || isNativeAccountActive() || typeof window.fetch !== 'function') {
      return Promise.resolve(true);
    }
    var force = !!(options && options.force);
    var now = Date.now();
    if (authProbePromise) return authProbePromise;
    if (!force && now - lastAuthProbeAt < AUTH_PROBE_INTERVAL_MS) return Promise.resolve(true);
    lastAuthProbeAt = now;

    authProbePromise = window.fetch(authProbeUrl(), {
      method: 'GET',
      credentials: 'same-origin',
      cache: 'no-store',
      headers: { Accept: 'text/html' }
    }).then(function (response) {
      if (!response || !response.ok) return null;
      return response.text();
    }).then(function (html) {
      var serverAuthenticated = parsedAuthState(html);
      if (serverAuthenticated == null) return true;
      var renderedAuthenticated = rootIsAuthenticated(instance.root);
      if (serverAuthenticated !== renderedAuthenticated) {
        emit('florame:auth-stale', {
          renderedAuthenticated: renderedAuthenticated,
          serverAuthenticated: serverAuthenticated
        });
        window.location.reload();
        return false;
      }
      syncClientAuthFromServer(instance);
      return true;
    }).catch(function () {
      return true;
    }).finally(function () {
      authProbePromise = null;
    });
    return authProbePromise;
  }

  function waitForShopifyInboxToggle() {
    var controller = window.FlorameShopifyInbox;
    if (controller && typeof controller.waitForToggle === 'function') return controller.waitForToggle();
    return Promise.resolve(null);
  }

  function languageOf(root) {
    var raw = (root && root.getAttribute('data-language')) || storageGet(LANGUAGE_KEYS[0]) || document.documentElement.lang || 'it';
    return String(raw).toLowerCase().indexOf('en') === 0 ? 'en' : 'it';
  }

  function copyFor(root) {
    return COPY[languageOf(root)];
  }

  function currentLanguage() {
    var value = storageGet(LANGUAGE_KEYS[0]) || storageGet(LANGUAGE_KEYS[1]) || document.documentElement.lang || 'it';
    return String(value).slice(0, 2).toLowerCase();
  }

  function partnerSlug() {
    try {
      var params = new URLSearchParams(window.location.search);
      var query = params.get('partner') || params.get('partnerSlug');
      if (query) return String(query).trim();
    } catch (_) {}
    try {
      var context = window.FloramePartner && typeof window.FloramePartner.getContext === 'function'
        ? window.FloramePartner.getContext()
        : null;
      if (context && context.active && context.slug) return String(context.slug).trim();
    } catch (_) {}
    return '';
  }

  function safeCurrentReturnTo() {
    var value = String(window.location.pathname || '/') + String(window.location.search || '') + String(window.location.hash || '');
    return value.indexOf('//') === 0 ? '/' : value;
  }

  function safeReturnTo(value) {
    var fallback = safeCurrentReturnTo();
    if (!value) return fallback;
    try {
      var url = new URL(String(value), window.location.origin);
      if (url.origin !== window.location.origin) return fallback;
      var result = String(url.pathname || '/') + String(url.search || '') + String(url.hash || '');
      return result.indexOf('//') === 0 ? fallback : result;
    } catch (_) { return fallback; }
  }

  function authReturnTo(root) {
    return safeReturnTo(root && root.getAttribute('data-fac-auth-return-to'));
  }

  function decorateLink(anchor) {
    if (!anchor || !anchor.href) return;
    try {
      var url = new URL(anchor.href, window.location.origin);
      var slug = partnerSlug();
      var lang = currentLanguage();
      var authRoute = anchor.getAttribute('data-fac-auth-route');
      var isAccountHost = String(url.hostname || '').toLowerCase() === 'account.florame.ai';

      if (slug && !isAccountHost && !url.searchParams.has('partner') && !url.searchParams.has('partnerSlug')) {
        url.searchParams.set('partner', slug);
      }
      if (lang && !url.searchParams.has('lang')) url.searchParams.set('lang', lang);
      if (authRoute === 'login' || authRoute === 'register') {
        url.searchParams.set('return_to', authReturnTo(anchor.closest(ROOT_SELECTOR)));
      }
      anchor.href = url.toString();
    } catch (_) {}
  }

  function decorateLinks(root) {
    if (!root) return;
    Array.prototype.forEach.call(root.querySelectorAll('a[data-fac-route], a[data-fac-auth-route]'), decorateLink);
  }

  function rememberAuthContext(root, options) {
    var opts = options || {};
    var returnTo = safeReturnTo(opts.returnTo);
    var intent = String(opts.intent || 'account').trim().slice(0, 80) || 'account';
    if (root) {
      root.setAttribute('data-fac-auth-return-to', returnTo);
      root.setAttribute('data-fac-auth-intent', intent);
    }
    try {
      window.sessionStorage.setItem(AUTH_CONTEXT_KEY, JSON.stringify({
        returnTo: returnTo,
        intent: intent,
        scrollY: Math.max(0, Math.round(window.scrollY || 0)),
        savedAt: Date.now()
      }));
    } catch (_) {}
    return { returnTo: returnTo, intent: intent };
  }

  function restoreAuthContext(instance) {
    if (!instance || !rootIsAuthenticated(instance.root)) return;
    var saved = null;
    try { saved = JSON.parse(window.sessionStorage.getItem(AUTH_CONTEXT_KEY) || 'null'); } catch (_) {}
    if (!saved || safeReturnTo(saved.returnTo) !== safeCurrentReturnTo()) return;
    try { window.sessionStorage.removeItem(AUTH_CONTEXT_KEY); } catch (_) {}
    if (!Number.isFinite(Number(saved.scrollY))) return;
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () { window.scrollTo(0, Math.max(0, Number(saved.scrollY))); });
    });
  }

  function focusables(panel) {
    if (!panel) return [];
    return Array.prototype.filter.call(
      panel.querySelectorAll('a[href], button:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])'),
      function (node) { return !node.hidden && node.offsetParent !== null && node.getAttribute('aria-hidden') !== 'true'; }
    );
  }

  function setSwitch(button, options) {
    if (!button) return;
    var opts = options || {};
    button.classList.toggle('is-on', !!opts.on);
    button.classList.toggle('is-checking', !!opts.checking);
    button.classList.toggle('is-error', !!opts.error);
    button.classList.toggle('is-action', !!opts.action);
    button.disabled = !!opts.disabled;
    if (button.hasAttribute('data-fac-haptics')) button.setAttribute('aria-checked', opts.on ? 'true' : 'false');
    else button.setAttribute('aria-pressed', opts.on ? 'true' : 'false');
    var status = button.querySelector('[data-fac-notifications-status], [data-fac-haptics-status]');
    if (status && opts.label) status.textContent = opts.label;
  }

  function pushLabel(root, state) {
    var c = copyFor(root);
    if (!state || state.supported === false) return c.unsupported;
    if (state.permission === 'denied') return c.denied;
    if (state.platform === 'ios' && state.standalone === false && !state.subscribed) return c.installFirst;
    if (state.subscribed) return c.active;
    if (state.permission === 'granted') return c.complete;
    return c.inactive;
  }

  function applyPushState(instance, state, options) {
    var button = instance.notifications;
    if (!button) return;
    var opts = options || {};
    var denied = state && state.permission === 'denied';
    var unsupported = state && state.supported === false;
    setSwitch(button, {
      on: !!(state && state.subscribed),
      checking: !!opts.checking,
      error: !!opts.error || denied,
      disabled: !!opts.checking || !!unsupported,
      action: !!opts.action || denied,
      label: opts.label || (opts.error ? copyFor(instance.root).notificationsError : pushLabel(instance.root, state))
    });
    instance.pushState = state || null;
  }

  function nativePushAvailable() {
    return !!(window.FlorameNative && window.FlorameNative.isNative && typeof window.FlorameNative.requestNotifications === 'function');
  }

  function immediateWebPushState(api) {
    if (api && typeof api.peekStatus === 'function') {
      try { return api.peekStatus(); } catch (_) {}
    }
    var supported = 'serviceWorker' in navigator && 'Notification' in window && 'PushManager' in window;
    var permission = 'Notification' in window ? Notification.permission : 'unsupported';
    return {
      supported: supported,
      permission: permission,
      subscribed: supported && permission === 'granted' && !!storageGet(WEB_PUSH_HASH_KEY),
      platform: 'web',
      verified: false
    };
  }

  function refreshPush(instance) {
    if (!instance.notifications) return Promise.resolve(null);
    var c = copyFor(instance.root);
    var refreshId = (instance.pushRefreshId || 0) + 1;
    instance.pushRefreshId = refreshId;
    if (nativePushAvailable()) {
      if (instance.pushState && instance.pushState.platform === 'native') applyPushState(instance, instance.pushState);
      else setSwitch(instance.notifications, { checking: true, label: c.checking });
      var nativeStatus = typeof window.FlorameNative.notificationStatus === 'function'
        ? window.FlorameNative.notificationStatus()
        : window.FlorameNative.requestNotifications({ prompt: false, source: 'account_center_status' });
      return Promise.resolve(nativeStatus)
        .then(function (state) {
          if (refreshId !== instance.pushRefreshId) return instance.pushState;
          var normalized = state || { supported: true, subscribed: false, permission: 'default', platform: 'native' };
          normalized.platform = 'native';
          instance.nativePushActive = !!normalized.subscribed;
          applyPushState(instance, normalized, { action: !normalized.subscribed, label: normalized.subscribed ? c.nativeActive : c.nativeAction });
          return normalized;
        })
        .catch(function () {
          if (refreshId !== instance.pushRefreshId) return instance.pushState;
          var fallback = instance.pushState || { supported: true, subscribed: false, permission: 'default', platform: 'native' };
          applyPushState(instance, fallback, { action: true, error: true, label: c.notificationsError });
          return fallback;
        });
    }

    var api = window.FlorameWebPush;
    var immediate = immediateWebPushState(api);
    applyPushState(instance, immediate);
    if (!api || typeof api.status !== 'function') {
      return Promise.resolve(immediate);
    }

    return Promise.resolve(api.status()).then(function (state) {
      if (refreshId !== instance.pushRefreshId) return instance.pushState;
      applyPushState(instance, state || { supported: false });
      return state;
    }).catch(function () {
      if (refreshId !== instance.pushRefreshId) return instance.pushState;
      applyPushState(instance, { supported: true }, { error: true, label: c.unavailable });
      return null;
    });
  }

  function togglePush(instance) {
    if (!instance || !instance.notifications || instance.notifications.disabled) return;
    instance.pushRefreshId = (instance.pushRefreshId || 0) + 1;
    var c = copyFor(instance.root);
    if (instance.pushState && instance.pushState.permission === 'denied') {
      applyPushState(instance, instance.pushState, { action: true, error: true, label: c.deniedHelp });
      return;
    }
    if (nativePushAvailable()) {
      setSwitch(instance.notifications, { on: !!(instance.pushState && instance.pushState.subscribed), checking: true, action: true, label: c.checking });
      Promise.resolve(window.FlorameNative.requestNotifications({ prompt: true, source: 'account_center' }))
        .then(function (result) {
          instance.nativePushActive = !!(result && result.permission === 'granted');
          applyPushState(instance, { supported: true, subscribed: instance.nativePushActive, permission: result && result.permission, platform: 'native' }, { action: true, label: instance.nativePushActive ? c.nativeActive : c.nativeAction });
        })
        .catch(function (error) {
          var denied = error && (error.permission === 'denied' || error.permission === 'prompt-with-rationale');
          applyPushState(instance, { supported: true, subscribed: false, permission: denied ? 'denied' : 'default', platform: 'native' }, { action: true, error: true, label: denied ? c.denied : c.notificationsError });
        });
      return;
    }

    var api = window.FlorameWebPush;
    if (!api || typeof api.setEnabled !== 'function') {
      applyPushState(instance, { supported: true }, { error: true, label: c.unavailable });
      return;
    }
    var target = !(instance.pushState && instance.pushState.subscribed);
    setSwitch(instance.notifications, { on: target, checking: true, label: c.checking });
    Promise.resolve(api.setEnabled(target))
      .then(function (state) { applyPushState(instance, state || { supported: true, subscribed: target }); })
      .catch(function () { refreshPush(instance).then(function () {
        if (!instance.pushState || instance.pushState.permission !== 'denied') {
          setSwitch(instance.notifications, { on: !!(instance.pushState && instance.pushState.subscribed), error: true, label: c.notificationsError });
        }
      }); });
  }

  function hapticsSupported() {
    try {
      if (window.FlorameHaptics && typeof window.FlorameHaptics.supported === 'function') return window.FlorameHaptics.supported();
      if (typeof navigator === 'undefined' || typeof navigator.vibrate !== 'function') return false;
      var userAgent = String(navigator.userAgent || '');
      var isIos = /iPad|iPhone|iPod/i.test(userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
      var isMobile = navigator.userAgentData && typeof navigator.userAgentData.mobile === 'boolean'
        ? navigator.userAgentData.mobile
        : /Android|Mobi/i.test(userAgent);
      return !isIos && isMobile;
    } catch (_) {
      return false;
    }
  }

  function hapticsEnabled() {
    try {
      if (window.FlorameHaptics && typeof window.FlorameHaptics.enabled === 'function') return window.FlorameHaptics.enabled();
    } catch (_) {}
    return storageGet(HAPTICS_KEY) !== '0';
  }

  function refreshHaptics(instance) {
    if (!instance.haptics) return;
    var c = copyFor(instance.root);
    instance.haptics.hidden = !hapticsSupported();
    if (instance.haptics.hidden) return;
    var enabled = hapticsEnabled();
    setSwitch(instance.haptics, { on: enabled, label: enabled ? c.hapticsOn : c.hapticsOff });
  }

  function toggleHaptics(instance) {
    if (!instance || !instance.haptics || instance.haptics.disabled) return;
    var next = !hapticsEnabled();
    try {
      if (window.FlorameHaptics && typeof window.FlorameHaptics.setEnabled === 'function') {
        next = window.FlorameHaptics.setEnabled(next);
      } else {
        storageSet(HAPTICS_KEY, next ? '1' : '0');
        emit('florame:hapticschange', { enabled: next });
      }
    } catch (_) {
      storageSet(HAPTICS_KEY, next ? '1' : '0');
    }
    refreshHaptics(instance);
    if (next && window.FlorameHaptics && typeof window.FlorameHaptics.vibrate === 'function') {
      try { window.FlorameHaptics.vibrate([12, 24, 12]); } catch (_) {}
    }
  }

  function refreshTheme(instance) {
    storageSet(THEME_KEY, 'light');
    document.documentElement.setAttribute('data-theme', 'light');
    if (instance.theme) instance.theme.value = 'light';
  }

  function syncInstall(instance, detail) {
    if (!instance.install) return;
    var api = window.FlorameWebPush;
    var native = !!(window.FlorameNative && window.FlorameNative.isNative);
    var installed = detail && typeof detail.installed === 'boolean'
      ? detail.installed
      : !!(api && typeof api.isInstalled === 'function' && api.isInstalled());
    var installable = detail && typeof detail.installable === 'boolean'
      ? detail.installable
      : document.documentElement.getAttribute('data-florame-pwa-installable') === '1';
    var mobileInstructions = !!(api && ((typeof api.isAppleTouchDevice === 'function' && api.isAppleTouchDevice()) || (typeof api.isAndroidDevice === 'function' && api.isAndroidDevice())));
    instance.install.hidden = native || installed || !api || typeof api.showInstall !== 'function' || (!installable && !mobileInstructions);
  }

  function openInstall(instance) {
    if (!instance.install || instance.install.hidden) return;
    var api = window.FlorameWebPush;
    if (!api || typeof api.showInstall !== 'function') return;
    instance.install.setAttribute('aria-busy', 'true');
    var status = instance.install.querySelector('small');
    var previous = status ? status.textContent : '';
    if (status) status.textContent = copyFor(instance.root).installing;
    try { api.showInstall(); } catch (_) {}
    window.setTimeout(function () {
      instance.install.removeAttribute('aria-busy');
      if (status) status.textContent = previous;
      syncInstall(instance);
    }, 900);
  }

  function changeLanguage(instance) {
    var select = instance.language;
    if (!select) return;
    var language = String(select.value || 'it').slice(0, 8);
    LANGUAGE_KEYS.forEach(function (key) { storageSet(key, language); });
    emit('florame:native-language-change', { language: language.slice(0, 2) });
    var form = select.closest('form');
    if (form) {
      if (typeof form.requestSubmit === 'function') form.requestSubmit();
      else form.submit();
    }
  }

  function refreshCapabilities(instance) {
    if (!instance) return Promise.resolve();
    decorateLinks(instance.root);
    refreshHaptics(instance);
    refreshTheme(instance);
    syncInstall(instance);
    return refreshPush(instance);
  }

  function AccountCenter(root) {
    this.root = root;
    this.panel = root.querySelector('.fac__panel');
    this.notifications = root.querySelector('[data-fac-notifications]');
    this.haptics = root.querySelector('[data-fac-haptics]');
    this.theme = root.querySelector('[data-fac-theme]');
    this.language = root.querySelector('[data-fac-language]');
    this.install = root.querySelector('[data-fac-install]');
    this.helpButton = root.querySelector('[data-fac-help]');
    this.helpView = root.querySelector('[data-fac-help-view]');
    this.helpBack = root.querySelector('[data-fac-help-back]');
    this.chatButtons = root.querySelectorAll('[data-fac-chat]');
    this.chatStatus = root.querySelector('[data-fac-chat-status]');
    this.title = root.querySelector('.fac__title');
    this.description = root.querySelector('.fac__description');
    this.scroll = root.querySelector('.fac__scroll');
    this.accountTitle = this.title ? this.title.textContent : '';
    this.accountDescription = this.description ? this.description.textContent : '';
    this.lastTrigger = null;
    this.restoreTriggerFocusOnClose = true;
    this.closeTimer = 0;
    this.pushState = null;
    this.pushRefreshId = 0;
    this.nativePushActive = false;
    this.dragState = null;
    this.bind();
    decorateLinks(root);
    syncClientAuthFromServer(this);
    lastAuthProbeAt = Date.now();
    refreshHaptics(this);
    refreshTheme(this);
    syncInstall(this);
  }

  AccountCenter.prototype.bind = function () {
    var self = this;
    Array.prototype.forEach.call(this.root.querySelectorAll('[data-fac-close]'), function (button) {
      button.addEventListener('click', function () { self.close(); });
    });
    if (this.notifications) this.notifications.addEventListener('click', function () { togglePush(self); });
    if (this.haptics) this.haptics.addEventListener('click', function () { toggleHaptics(self); });
    if (this.language) this.language.addEventListener('change', function () { changeLanguage(self); });
    if (this.install) this.install.addEventListener('click', function () { openInstall(self); });
    if (this.helpButton) this.helpButton.addEventListener('click', function () { self.openHelp(); });
    if (this.helpBack) this.helpBack.addEventListener('click', function () { self.closeHelp(); });
    Array.prototype.forEach.call(this.chatButtons, function (button) {
      button.addEventListener('click', function (event) { self.openChat(event); });
    });
    this.root.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') { event.preventDefault(); self.close(); return; }
      if (event.key !== 'Tab') return;
      var items = focusables(self.panel);
      if (!items.length) { event.preventDefault(); self.panel.focus(); return; }
      var first = items[0];
      var last = items[items.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    });
    this.bindSwipeToClose();
  };

  AccountCenter.prototype.bindSwipeToClose = function () {
    var self = this;
    var surfaces = this.root.querySelectorAll('[data-fac-drag-surface]');

    function resetDrag() {
      self.dragState = null;
      self.root.classList.remove('is-dragging');
      self.root.style.removeProperty('--fac-drag-y');
      self.root.style.removeProperty('--fac-drag-backdrop');
    }

    function onPointerDown(event) {
      if (self.root.hidden || !self.root.classList.contains('is-open')) return;
      if (event.button != null && event.button !== 0) return;
      if (event.target && event.target.closest && event.target.closest('button,a,input,select,textarea')) return;
      self.dragState = {
        pointerId: event.pointerId,
        startY: event.clientY,
        lastY: event.clientY,
        lastTime: event.timeStamp || Date.now(),
        velocity: 0
      };
      self.root.classList.remove('is-swipe-closing');
      self.root.classList.add('is-dragging');
      try { event.currentTarget.setPointerCapture(event.pointerId); } catch (_) {}
    }

    function onPointerMove(event) {
      var state = self.dragState;
      if (!state || state.pointerId !== event.pointerId) return;
      var y = Number(event.clientY || 0);
      var delta = Math.max(0, y - state.startY);
      var now = event.timeStamp || Date.now();
      var elapsed = Math.max(1, now - state.lastTime);
      state.velocity = Math.max(0, (y - state.lastY) / elapsed);
      state.lastY = y;
      state.lastTime = now;
      self.root.style.setProperty('--fac-drag-y', delta.toFixed(1) + 'px');
      self.root.style.setProperty('--fac-drag-backdrop', String(Math.max(.18, 1 - delta / Math.max(280, window.innerHeight * .72))));
      if (delta > 4) event.preventDefault();
    }

    function onPointerEnd(event) {
      var state = self.dragState;
      if (!state || state.pointerId !== event.pointerId) return;
      var delta = Math.max(0, Number(event.clientY || state.lastY) - state.startY);
      var threshold = Math.max(92, Math.min(140, window.innerHeight * .13));
      var shouldClose = event.type !== 'pointercancel' && (delta >= threshold || (delta >= 48 && state.velocity > .55));
      try { event.currentTarget.releasePointerCapture(event.pointerId); } catch (_) {}
      resetDrag();
      if (shouldClose) {
        self.root.classList.add('is-swipe-closing');
        self.close();
      }
    }

    Array.prototype.forEach.call(surfaces, function (surface) {
      surface.addEventListener('pointerdown', onPointerDown);
      surface.addEventListener('pointermove', onPointerMove);
      surface.addEventListener('pointerup', onPointerEnd);
      surface.addEventListener('pointercancel', onPointerEnd);
    });
  };

  AccountCenter.prototype.open = function (trigger, restoreTriggerFocusOnClose) {
    var self = this;
    if (this.closeTimer) { window.clearTimeout(this.closeTimer); this.closeTimer = 0; }
    this.lastTrigger = trigger || document.activeElement;
    this.restoreTriggerFocusOnClose = restoreTriggerFocusOnClose !== false;
    this.dragState = null;
    this.root.classList.remove('is-dragging', 'is-swipe-closing');
    this.root.style.removeProperty('--fac-drag-y');
    this.root.style.removeProperty('--fac-drag-backdrop');
    this.root.hidden = false;
    document.body.classList.add('fac-scroll-locked');
    if (trigger) trigger.setAttribute('aria-expanded', 'true');
    window.requestAnimationFrame(function () {
      self.root.classList.add('is-open');
      self.panel.focus({ preventScroll: true });
    });
    refreshCapabilities(this);
    syncClientAuthFromServer(this);
    ensureAuthFresh(this);
    emit('florame:account-center-open', { authenticated: this.root.getAttribute('data-authenticated') === 'true' });
  };

  AccountCenter.prototype.openHelp = function () {
    if (!this.helpView) return;
    var c = copyFor(this.root);
    this.helpView.hidden = false;
    this.root.classList.add('is-help-view');
    if (this.title) this.title.textContent = c.helpTitle;
    if (this.description) this.description.textContent = c.helpDescription;
    if (this.chatStatus) this.chatStatus.textContent = '';
    if (this.scroll) this.scroll.scrollTop = 0;
    var firstSummary = this.helpView.querySelector('summary');
    if (firstSummary && typeof firstSummary.focus === 'function') firstSummary.focus({ preventScroll: true });
    emit('florame:account-help-open');
  };

  AccountCenter.prototype.closeHelp = function (restoreFocus) {
    this.root.classList.remove('is-help-view');
    if (this.helpView) this.helpView.hidden = true;
    if (this.title) this.title.textContent = this.accountTitle;
    if (this.description) this.description.textContent = this.accountDescription;
    if (this.chatStatus) this.chatStatus.textContent = '';
    if (this.scroll) this.scroll.scrollTop = 0;
    if (restoreFocus !== false && this.helpButton && typeof this.helpButton.focus === 'function') this.helpButton.focus({ preventScroll: true });
  };

  AccountCenter.prototype.openChat = function (event) {
    var self = this;
    var c = copyFor(this.root);
    var sourceButton = event && event.currentTarget ? event.currentTarget : null;
    try { event.preventDefault(); event.stopPropagation(); } catch (_) {}
    if (sourceButton) sourceButton.setAttribute('aria-busy', 'true');
    if (this.chatStatus) this.chatStatus.textContent = c.chatOpening;

    waitForShopifyInboxToggle().then(function (button) {
      if (!button) {
        if (sourceButton) sourceButton.removeAttribute('aria-busy');
        if (self.chatStatus) self.chatStatus.textContent = c.chatUnavailable;
        emit('florame:shopify-inbox-unavailable');
        return;
      }

      self.close(false);
      window.setTimeout(function () {
        var controller = window.FlorameShopifyInbox;
        var opener = controller && typeof controller.open === 'function'
          ? controller.open
          : window.openShopifyInboxFromMenu;
        var result = typeof opener === 'function'
          ? opener({ preventDefault: function () {}, stopPropagation: function () {} })
          : false;
        Promise.resolve(result).then(function (opened) {
          if (sourceButton) sourceButton.removeAttribute('aria-busy');
          if (opened === false) {
            emit('florame:shopify-inbox-unavailable');
            return;
          }
          emit('florame:shopify-inbox-opened');
        });
      }, 260);
    });
  };

  AccountCenter.prototype.close = function (restoreFocus) {
    var self = this;
    if (this.root.hidden) return;
    this.root.classList.remove('is-open');
    document.body.classList.remove('fac-scroll-locked');
    if (this.lastTrigger) this.lastTrigger.setAttribute('aria-expanded', 'false');
    this.closeTimer = window.setTimeout(function () {
      self.root.hidden = true;
      self.root.classList.remove('is-dragging', 'is-swipe-closing');
      self.root.style.removeProperty('--fac-drag-y');
      self.root.style.removeProperty('--fac-drag-backdrop');
      self.dragState = null;
      self.closeHelp(false);
      self.closeTimer = 0;
    }, 240);
    var shouldRestoreFocus = restoreFocus === true || (restoreFocus !== false && this.restoreTriggerFocusOnClose);
    if (shouldRestoreFocus && this.lastTrigger && typeof this.lastTrigger.focus === 'function') {
      try { this.lastTrigger.focus({ preventScroll: true }); } catch (_) { this.lastTrigger.focus(); }
    } else if (this.lastTrigger && typeof this.lastTrigger.blur === 'function') {
      // iOS Safari can keep a native ring around a tapped trigger after the sheet closes.
      // Pointer users do not need focus restoration; keyboard and assistive activation still do.
      this.lastTrigger.blur();
    }
    emit('florame:account-center-close');
  };

  function init(scope) {
    var context = scope && scope.querySelectorAll ? scope : document;
    var roots = [];
    if (scope && scope.matches && scope.matches(ROOT_SELECTOR)) roots.push(scope);
    Array.prototype.push.apply(roots, context.querySelectorAll(ROOT_SELECTOR));
    roots.forEach(function (root) {
      if (root.__florameAccountCenter) return;
      var instance = new AccountCenter(root);
      root.__florameAccountCenter = instance;
      instances.push(instance);
    });
    Array.prototype.forEach.call(document.querySelectorAll(TRIGGER_SELECTOR), function (trigger) {
      trigger.setAttribute('aria-haspopup', 'dialog');
      trigger.setAttribute('aria-controls', 'FlorameAccountCenter');
      if (!trigger.hasAttribute('aria-expanded')) trigger.setAttribute('aria-expanded', 'false');
      trigger.style.touchAction = 'manipulation';
    });
    return instances;
  }

  function firstInstance() {
    if (!instances.length) init(document);
    return instances[0] || null;
  }

  function openUtility(instance, kind) {
    if (!instance) return null;
    var utility = String(kind || '').toLowerCase();
    refreshCapabilities(instance);
    if (utility === 'install') {
      openInstall(instance);
      return instance;
    }

    instance.open(null, false);
    window.requestAnimationFrame(function () {
      if (utility === 'help') {
        instance.openHelp();
        return;
      }
      if (utility !== 'language' || !instance.language) return;
      try { instance.language.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (_) {}
      window.setTimeout(function () {
        try { instance.language.focus({ preventScroll: true }); } catch (_) { instance.language.focus(); }
      }, 180);
    });
    return instance;
  }

  function activateTrigger(trigger, restoreTriggerFocusOnClose) {
    var instance = firstInstance();
    if (instance) instance.open(trigger, restoreTriggerFocusOnClose);
    return instance;
  }

  function requestAuth(options) {
    var opts = options || {};
    var instance = firstInstance();
    if (!instance) return null;
    var context = {
      returnTo: safeReturnTo(opts.returnTo),
      intent: String(opts.intent || 'account').trim().slice(0, 80) || 'account'
    };
    if (rootIsAuthenticated(instance.root) || isNativeAccountActive()) {
      emit('florame:auth-ready', {
        authenticated: true,
        intent: context.intent,
        returnTo: context.returnTo
      });
      return instance;
    }
    context = rememberAuthContext(instance.root, context);
    decorateLinks(instance.root);
    var c = copyFor(instance.root);
    if (instance.title) instance.title.textContent = c.authTitle;
    if (instance.description && context.intent.indexOf('message') === 0) {
      instance.description.textContent = c.authMessagesDescription;
    }
    instance.open(opts.trigger || null, true);
    emit('florame:auth-requested', {
      intent: context.intent,
      returnTo: context.returnTo,
      trigger: opts.trigger || null
    });
    return instance;
  }

  function cancelPointerActivation(trigger) {
    if (trigger && pendingPointerTrigger && trigger !== pendingPointerTrigger) return;
    if (pointerActivationTimer) window.clearTimeout(pointerActivationTimer);
    pointerActivationTimer = 0;
    pendingPointerTrigger = null;
  }

  function schedulePointerActivation(trigger) {
    cancelPointerActivation();
    pendingPointerTrigger = trigger;
    pointerActivationTimer = window.setTimeout(function () {
      var queuedTrigger = pendingPointerTrigger;
      pointerActivationTimer = 0;
      pendingPointerTrigger = null;
      if (queuedTrigger && queuedTrigger.isConnected !== false) activateTrigger(queuedTrigger, false);
    }, 380);
  }

  document.addEventListener('pointerup', function (event) {
    if (event.pointerType !== 'touch' && event.pointerType !== 'pen') return;
    var trigger = event.target && event.target.closest ? event.target.closest(TRIGGER_SELECTOR) : null;
    if (!trigger) return;
    schedulePointerActivation(trigger);
  }, true);

  document.addEventListener('click', function (event) {
    var trigger = event.target && event.target.closest ? event.target.closest(TRIGGER_SELECTOR) : null;
    if (!trigger) return;
    event.preventDefault();
    cancelPointerActivation(trigger);
    activateTrigger(trigger, event.detail === 0);
  }, true);

  window.addEventListener('florame:account-utility', function (event) {
    var utility = event && event.detail ? event.detail.utility : '';
    openUtility(firstInstance(), utility);
  });
  window.addEventListener('florame:request-auth', function (event) {
    requestAuth(event && event.detail ? event.detail : {});
  });

  window.addEventListener('pageshow', function (event) {
    instances.forEach(function (instance) {
      refreshCapabilities(instance);
      if (event && event.persisted) ensureAuthFresh(instance, { force: true });
      else syncClientAuthFromServer(instance);
    });
  });
  window.addEventListener('focus', function () {
    var instance = firstInstance();
    if (instance) ensureAuthFresh(instance);
  });
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState !== 'visible') return;
    var instance = firstInstance();
    if (instance) ensureAuthFresh(instance);
  });
  window.addEventListener('florame:web-push-state', function (event) {
    instances.forEach(function (instance) {
      instance.pushRefreshId = (instance.pushRefreshId || 0) + 1;
      applyPushState(instance, event && event.detail ? event.detail : {});
    });
  });
  window.addEventListener('florame:web-push-ready', function () { instances.forEach(refreshPush); });
  window.addEventListener('florame:native-push-token', function () {
    instances.forEach(function (instance) {
      instance.nativePushActive = true;
      applyPushState(instance, { supported: true, subscribed: true, permission: 'granted', platform: 'native' }, { action: true, label: copyFor(instance.root).nativeActive });
    });
  });
  window.addEventListener('florame:hapticschange', function () { instances.forEach(refreshHaptics); });
  window.addEventListener('florame:pwa-install-state', function (event) {
    instances.forEach(function (instance) { syncInstall(instance, event && event.detail ? event.detail : {}); });
  });
  window.addEventListener('florame:native-ready', function () { instances.forEach(refreshCapabilities); });
  window.addEventListener('florame:partner-ready', function () { instances.forEach(function (instance) { decorateLinks(instance.root); }); });
  window.FlorameAccountCenter = Object.assign({}, window.FlorameAccountCenter || {}, {
    version: '1.6.0',
    init: init,
    open: function (trigger) { var instance = firstInstance(); if (instance) instance.open(trigger || null, true); return instance; },
    requestAuth: requestAuth,
    openUtility: function (kind) { return openUtility(firstInstance(), kind); },
    install: function () { return openUtility(firstInstance(), 'install'); },
    canInstall: function () {
      var instance = firstInstance();
      if (!instance) return false;
      syncInstall(instance);
      return !!(instance.install && !instance.install.hidden);
    },
    close: function () { instances.forEach(function (instance) { instance.close(); }); },
    refreshCapabilities: function () { return Promise.all(instances.map(refreshCapabilities)); },
    refreshAuth: function () { var instance = firstInstance(); return instance ? ensureAuthFresh(instance, { force: true }) : Promise.resolve(true); },
    decorateLinks: function () { instances.forEach(function (instance) { decorateLinks(instance.root); }); }
  });

  if (window.__floramePendingAuthRequest) {
    var pendingAuthRequest = window.__floramePendingAuthRequest;
    window.__floramePendingAuthRequest = null;
    window.requestAnimationFrame(function () { requestAuth(pendingAuthRequest); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () {
    init(document);
    restoreAuthContext(firstInstance());
  }, { once: true });
  else {
    init(document);
    restoreAuthContext(firstInstance());
  }
})();
